module.exports = __webpack_public_path__ + "img/burger-king.a07b4fe9.jpg";